<template>
    <CardOption
        class="card-image-card"
        v-bind="{ card, questionnaireStore, isSelected }"
        @click.prevent.stop="$emit('toggle', !isSelected)"
    >
        <div class="image-wrapper">
            <CmsImage
                :data="content.image"
                :is-eager="true"
                class="image"
                fit="contain"
            />
        </div>

        <div class="details">
            <h3 class="name">{{ content.title }}</h3>

            <div class="description">
                {{ content.description }}
            </div>
        </div>
    </CardOption>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import type { QuestionnaireQuestionChoiceOptionContentImageCardFragment } from '@/graphql/api'
import type { QuestionnaireStore } from '@/components/cms/component/questionnaire/useQuestionnaireStore'
import { getOptionContent } from '../composables/evaluateConditions.ts'

import CardOption from './CardOption.vue'
import CmsImage from '@/components/cms/CmsImage.vue'

const props = defineProps<{
    card: QuestionnaireQuestionChoiceOptionContentImageCardFragment
    questionnaireStore: QuestionnaireStore
    isSelected: boolean | undefined
}>()

defineEmits<{
    'toggle': [select: boolean]
}>()

const route = useRoute()

const content = computed(() =>
    getOptionContent(
        props.card,
        props.questionnaireStore,
        route.params['id'] as string
    )
)
</script>
<style lang="scss" scoped>
.card-image-card {
    margin: 3px;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: space-between;

    @include min-width(360) {
        width: calc(50% - 6px);
    }

    @include min-width(1024) {
        width: calc(25% - 6px);
    }

    .image-wrapper {
        width: 100%;
        aspect-ratio: 1/1;

        .image {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    .details {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        padding: 0 10px 10px;
        align-self: flex-end;

        @include min-width(640) {
            padding: 0 20px 20px;
        }

        .name {
            font-family: $parcel-font-stack;
            letter-spacing: 0.01em;
            font-size: 1rem;
            line-height: 1em;
            color: $blue;
            width: 100%;
            margin: 0 0 5px;
        }

        .description {
            width: 100%;
            font-size: 0.75rem;
            margin: 0 0 10px;
        }
    }
}
</style>
